export default {
  create: (state, payload) => {
    state.items.push(payload)
  }
}



// WEBPACK FOOTER //
// ./assets/js/store/modules/decor/mutations.js